import firebase from 'firebase';
import dayjs from 'dayjs';


export const createUserStat = async ({phone, name, email, company}) => {
  const uid = firebase.auth().currentUser.uid;

  return await firebase.firestore().collection('userStat').add({
    // customer: 'new',
    // place_registration: 'web',
    customer: 'new_guest',
    place_registration: 'ios',
    own_projects: 0,
    is_picked: false,
    invited_users_own_projects: 0,
    createDate: dayjs(dayjs().utc().format('YYYY-MM-DD')).unix(),
    phone, name, email, company,
    uid,
  });
};



// WEBPACK FOOTER //
// ./src/firestore/stat.js